<template>
  <div class="pad30">
    <goodsDrawer
      v-if="goodsAddVisible"
      :goodsNum.sync="goodsNum"
      :show.sync="goodsAddVisible"
      :selections.sync="selections"
      :categoryList.sync="categoryList"
      :disChooseList.sync="disChooseList"
      :disableSKUSelection.sync="disableSKUSelection"
    />
    <div class="f14 flex radius5 pad10 tips mar15-b">
      <i class="el-icon-info blue mar10-r mar5-t"></i>
      <div class="flex-auto">
        <div class="f15 mar5-b">操作须知</div>
        <div class="gray6">
          本功能属于高阶操作，适用于商品sku调整SPU归属（仅支持单规格商品及单规格项的多规格商品），请在农信商城运营老师培训、指导下进行使用，以免数据偏差
        </div>
      </div>
    </div>
    <div class="flex">
      <Card class="flex-auto">
        <template slot="header">
          <div class="header flex items-center justify-between">
            <div class="pointer title">移出SKU</div>
            <el-button class="mar10-tb" type="primary" @click="goodOut">选择</el-button>
          </div>
        </template>
        <div class="pad20">
          <div class="mar10-b" v-if="!goodOutList.length">请选择需要移除的商品SKU</div>
          <el-table ref="multipleTable" max-height="500" row-key="id" :data="goodOutList">
            <el-table-column prop="name" show-overflow-tooltip label="商品名称" />
            <el-table-column fixed="right" label="操作" width="100">
              <template slot-scope="scope">
                <el-button v-if="!scope.row.children || !scope.row.specType" size="mini" type="primary" @click="delGood(scope.row.id)">移除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </Card>
      <Card class="mar20-l flex-auto">
        <template slot="header">
          <div class="header flex items-center justify-between">
            <div class="pointer title">移入商品</div>
            <div class="mar5-tb">
              <el-button type="primary" @click="addSpu">新增SPU</el-button>
              <el-button class="mar10-l" type="primary" @click="goodIn">选择</el-button>
            </div>
          </div>
        </template>
        <div class="pad20">
          <div class="mar10-b" v-if="!goodInList.length">请选择目标商品</div>
          <el-table ref="multipleTable" :data="goodInList">
            <el-table-column prop="name" show-overflow-tooltip label="商品名称" />
          </el-table>
        </div>
      </Card>
    </div>
    <div class="mar20-t text-right">
      <el-button type="primary" @click="goodShift">确定调整</el-button>
    </div>
    <el-dialog title="新增SPU" :visible.sync="addSpuVisible" width="550px" :close-on-click-modal="false">
      <div>
        <el-form :model="addSpuForm" :rules="rules" ref="addSpuForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="商品类目：" prop="categoryIdList">
            <el-cascader
              class="w240"
              :options="categoryList"
              clearable
              :props="categoryProps"
              v-model="addSpuForm.categoryIdList"
              @change="categoryChange"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="商品名称：" prop="name">
            <el-input class="w240" v-model="addSpuForm.name"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('addSpuForm')">确 定</el-button>
            <el-button @click="resetForm('addSpuForm')">取 消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Card from "@/components/Card";
import goodsDrawer from "@/components/goodsDrawer/index.vue";
import { getGoodsCategoryFirstLevel } from "@/api/publishGoods/publishGoods";
import { Loading, MessageBox } from "element-ui";

export default {
  components: {
    Card,
    goodsDrawer,
  },

  data() {
    return {
      env: process.env,
      categoryList: [],

      goodOutList: [],
      goodOutListOrg: [],

      goodInList: [],

      // 选择商品
      goodsNum: 999,
      selections: [],
      disChooseList: [],
      goodsAddVisible: false,
      disableSKUSelection: true,

      // 新增spu
      addSpuVisible: false,
      addSpuForm: {
        name: "",
        categoryId: "", // 分类ID
        categoryAxis: "", // 分类层级串 一二三级
        categoryIdList: [],
      },
      rules: {
        name: [{ required: true, message: "请输入商品名称", trigger: "blur" }],
        categoryIdList: [{ required: true, message: "请选择商品分类", trigger: "change" }],
      },
      categoryProps: {
        value: "id",
        label: "text",
        // checkStrictly: true,
      },
      loadingInstance: "",
    };
  },
  watch: {
    selections(newVal) {
      if (this.disableSKUSelection) {
        this.goodInList = newVal;
      } else {
        console.log("移出", newVal);
        this.goodOutListOrg = newVal || [];
        const list = newVal || [];
        const result = [];
        list.forEach((item) => {
          var { spuId, spuName, specType } = item;
          if (!result[spuId]) {
            result[spuId] = {
              specType,
              id: spuId,
              name: spuName,
              children: [],
            };
          }
          if (item.specType) {
            result[spuId].children.push(item);
          }
        });
        this.goodOutList = Object.values(result);
        console.log("this.goodOutList", this.goodOutList);
      }
    },
  },
  computed: mapState({
    userInfo: (state) => state.app.userInfo,
  }),
  created() {
    this.getGoodsCategory();
  },
  methods: {
    // 获取商品类目列表
    async getGoodsCategory() {
      const result = await getGoodsCategoryFirstLevel();
      this.categoryList = result.data || [];
      this.getTreeData(this.categoryList);
    },

    getTreeData(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].children.length < 1) {
          // 最后一级没有数据将children变成undefined
          data[i].children = undefined;
        } else {
          // children不为空时继续调用该方法
          this.getTreeData(data[i].children);
        }
      }
      return data;
    },

    // 移出的sku商品
    goodOut() {
      this.goodsNum = 999;
      this.selections = this.goodOutListOrg;
      this.disChooseList = this.goodInList.map((item) => {
        return item.spuId;
      });
      this.disableSKUSelection = false;
      this.goodsAddVisible = true;
    },

    // 移入的spu商品
    goodIn() {
      this.goodsNum = 1;
      this.selections = this.goodInList;
      this.disChooseList = this.goodOutListOrg.map((item) => {
        return item.spuId;
      });
      this.disableSKUSelection = true;
      this.goodsAddVisible = true;
    },

    categoryChange() {
      const { categoryIdList } = this.addSpuForm;
      const categoryId = categoryIdList[categoryIdList.length - 1];
      const categoryAxis = `$${categoryIdList.join("$")}`;
      console.log("categoryAxis", categoryAxis);
      this.addSpuForm = {
        ...this.addSpuForm,
        categoryId,
        categoryAxis,
      };
      console.log("addSpuForm", this.addSpuForm);
    },

    addSpu() {
      this.addSpuVisible = true;
      this.addSpuForm = {
        name: "",
        categoryId: "", // 分类ID
        categoryAxis: "", // 分类层级串 一二三级
        categoryIdList: [],
      };
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log("submitForm addSpuForm", this.addSpuForm);
          this.goodInList = [];
          this.goodInList.push(this.addSpuForm);
          this.addSpuVisible = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm() {
      this.addSpuVisible = false;
    },

    delGood(id) {
      MessageBox.confirm("是否要移除该商品？").then(() => {
        this.goodOutListOrg.forEach((item, index) => {
          if (item.id === id) {
            this.goodOutListOrg.splice(index, 1);
          }
        });
        this.goodInList.forEach((item, index) => {
          if (item.id === id) {
            item.splice(index, 1);
          }
          if (item.children) {
            item.children.forEach((item1, index1) => {
              if (item1.id === id) {
                item.splice(index1, 1);
              }
            });
          }
        });
        this.goodInList = this.goodInList.filter((item) => {
          if (!item.specType || (item.children && item.children.length)) {
            return item;
          }
        });
      });
    },

    goodShift() {
      const { goodInList, goodOutListOrg } = this;
      if (!goodOutListOrg.length) {
        this.$message.warning("请先选择要移出的SKU");
        return;
      }
      if (!goodInList.length) {
        this.$message.warning("请先新增或选择要移入的商品");
        return;
      }
      const transformFromSkuIdList = goodOutListOrg.map((item) => {
        return item.id;
      });
      const { name, spuId, categoryId, categoryAxis } = goodInList[0];
      const arg = {
        name,
        spuId,
        categoryId,
        categoryAxis,
        transformFromSkuIdList,
      };
      console.log("arg", arg);
      MessageBox.confirm(`确定调整当前商品SKU至 “${name}商品”`).then(() => {
        this.loadingInstance = Loading.service({
          lock: true,
          text: "商品调整中",
        });
        this.$store.dispatch("goodShift/updategoodSkuTransform", arg).then((res) => {
          this.loadingInstance.close();
          this.goodInList = [];
          this.goodOutList = [];
          this.goodOutListOrg = [];
          console.log("商品调整", res);
          const { code, msg } = res;
          if (code === "0") {
            this.$message.success("调整成功！");
          } else {
            this.$message.warning(msg);
          }
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "index.scss";
</style>
<style>
.el-select-dropdown__item.selected {
  color: #0095f1;
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #0095f1;
}
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #0095f1;
  border-color: #0095f1;
}
.el-checkbox__input.is-focus .el-checkbox__inner,
.el-checkbox__inner:hover,
.el-cascader .el-input.is-focus .el-input__inner {
  border-color: #0095f1;
}
.el-cascader-node.in-active-path,
.el-cascader-node.is-selectable.in-checked-path,
.el-cascader-node.is-active,
.el-loading-spinner .el-loading-text {
  color: #0095f1;
}
.el-loading-spinner .path {
  stroke: #0095f1;
}
</style>
